import script from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=16342d9c&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16342d9c"]])

export default __exports__